export default {
  custom: {
    city: {
      required: () => 'City is required'
    },
    company_id: {
      required: () => 'Company is required'
    },
    company_name: {
      required: () => 'Company name is required'
    },
    device_id: {
      required: () => 'Device ID is required'
    },
    device_name: {
      required: () => 'Device name is required'
    },
    first_name: {
      required: () => 'First name is required'
    },
    last_name: {
      required: () => 'Last name is required'
    },
    newPassword: {
      min: () => 'The New Password field must be at least 6 characters.',
      confirmed: () => 'The password confirmation does not match.'
    },
    organization_name: {
      required: () => 'Organization name is required'
    },
    postal_code: {
      required: () => 'Postal / Zip Code is required'
    },
    promotion_name: {
      required: () => 'Promotion name is required'
    },
    state_province: {
      required: () => 'Province / State is required'
    },
    street_address: {
      required: () => 'Street address is required'
    },
    verifyPassword: {
      required: () => 'Verify password is required',
      confirmed: () => 'The password confirmation does not match.'
    }
  }
}
